import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-400">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-500"></i>
          )}
          {item.href ? (
            <Link
              to={item.href}
              className="hover:text-primary-400 transition-colors duration-200"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-200">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}